import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

type CompetenceInput = {
  competenceId: number;
  workerId: number;
};

export const useDeleteWorkerCompetenceMutation = () => {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ competenceId }: CompetenceInput) =>
      api.deleteBackWorkersWorkerCompetencesP1Delete({
        p1: competenceId,
      }),
    onSuccess: (_, { workerId }) => queryClient.invalidateQueries({ queryKey: ['worker-competences', workerId] }),
  });
};
